'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TokenizedInput = require('./components/TokenizedInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TokenizedInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tokenized-input/lib/index.js
// module id = 1363
// module chunks = 1